module.exports = "/_next/static/images/low_volatility-8c1cbbea6fe1737ab0b900de0272ecfe.svg";